"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var FlagIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M15.6068 8.58288C15.5885 8.59027 13.6982 9.32186 12.1218 8.58956C10.7629 7.95711 9.26647 8.25312 8.57143 8.45281V8.28125C8.57143 8.12586 8.44357 8 8.28571 8C8.12785 8 8 8.12586 8 8.28125V16.7188C8 16.8741 8.12785 17 8.28571 17C8.44357 17 8.57143 16.8741 8.57143 16.7188V13.5427C9.07822 13.3814 10.5821 12.9954 11.8782 13.5979C12.4961 13.8855 13.1421 13.9811 13.7289 13.9811C14.8575 13.9811 15.765 13.6275 15.8214 13.605C15.9293 13.5614 16 13.4584 16 13.3438V8.84376C16 8.75024 15.9525 8.66306 15.8736 8.61103C15.7946 8.55827 15.6946 8.54843 15.6068 8.58288Z" }))); };
exports.FlagIcon = FlagIcon;
